import initVueApp from "@/core.js";
const component = require(`./../views/GridPromoTilesCollection.vue`).default;
initVueApp(component);
